import React, { useReducer } from 'react';
import axios from 'ps-components/lib/apiClient';
import { initialState, reducer } from './store';
import { Button, Group, Stack } from '@mantine/core';
import { useQuery } from 'react-query';
import { FormulasTab } from './Formulas';
import { ReportsTab } from './Reports/ReportsTab';

const ReportInspector = () => {
    const [state, dispatch] = useReducer(reducer, initialState)
    const { reportTab } = state

    const getSites = async () => {
        try {
            const response = await axios.apiGet(`/api/marketpay-internal/report-inspector/sites`)
            const siteUrls = response.data?.sites?.map((site: any) => site.url)
            return siteUrls
        } catch (error) {
            console.error(`Error fetching sites: ${error}`)
        }
    }

    const handleTabChange = (payload: 'reports' | 'formulas') => dispatch({ type: 'setReportTab', payload })

    const { data: sites } = useQuery(['sites'], getSites)

    return (
        <>
            <Stack gap={15}>
                <Group justify='space-between'>
                    <Group>
                        <Button size='lg' onClick={() => handleTabChange('reports')} variant={reportTab === 'reports' ? 'primary' : 'outline'}>
                            Reports
                        </Button>
                        <Button size='lg' onClick={() => handleTabChange('formulas')} variant={reportTab === 'formulas' ? 'primary' : 'outline'}>
                            Formulas
                        </Button>
                    </Group>
                </Group>
                { reportTab === 'reports' && <ReportsTab dispatch={dispatch} state={state} sites={sites} /> }
                { reportTab === 'formulas' && <FormulasTab state={state} dispatch={dispatch} sites={sites} /> }
            </Stack>
        </>
    )
}

export default ReportInspector
